import {FC} from "react";
import {Text} from "../../ui-components/text.tsx";
import UserIcon from "../../assets/images/userFilled.svg";
import {Table, TableBody, TableCell, TableRow} from "../../ui-components/table.tsx";
import BanIcon from "../../assets/images/ban.svg";
import CopyIcon from "../../assets/images/copy.svg";
import {formatNumber} from "../../utils/Utils.ts";
import {LightButton} from "../buttons/LightButton.tsx";
import {ToastContainer} from "react-toastify";
import {BottomSheet} from "../../container/ModalSheet.tsx";
import useStatisticsPlacementModal from "../../hooks/campaigns/useStatisticsPlacementModal.ts";
import {IsLoadingContainer} from "../../container/IsLoadingContainer.tsx";
import TrashIcon from "../../assets/images/trashBlack.svg";
import {useTranslation} from "react-i18next";


export const StatisticsPlacementModal: FC<{ isOpen: boolean, onClose: () => void }> = ({isOpen, onClose}) => {
    const {isLoading, data, blackListHandler, copyChannel, placementStats} = useStatisticsPlacementModal()

    const {t} = useTranslation();
    return (
        <BottomSheet isOpen={isOpen} onClose={onClose}>
            {
                <IsLoadingContainer isLoading={isLoading}>
                    {
                        data ?
                            <div className="w-full px-4 flex flex-col items-center relative overflow-hidden">
                                <ToastContainer className={'ToastContainer'} containerId={'publication_details_id'}
                                                style={{top: "23px"}}/>
                                <div className="w-10 h-0.5 bg-[var(--color-line)] my-2"></div>
                                <div className={"w-full h-full flex flex-col items-start justify-center "}>
                                    <Text className={"w-full mb-4 font-medium !text-black mt-4"}>
                                        {t('modals.statsPlacement.heading')}
                                    </Text>
                                    <div
                                        className={"w-full bg-white rounded-lg border border-[var(--btn-border-custom)] mb-[32px] px-4 py-3"}>
                                        <div className={"flex gap-1 mb-2"}>
                                            <div className={"rounded-md"}>
                                                <img src={data.channel.profile_image_url}
                                                     className={"object-fill max-w-10 max-h-10 rounded-md"}
                                                     alt={"l"}></img>
                                            </div>
                                            <div className={"flex flex-col ml-3 "}>
                                                <Text className={"!text-[16px] leading-3 !text-black font-semibold"}>
                                                    {data.channel.telegram_channel_name}
                                                </Text>
                                                <div className={"flex gap-1"}>
                                                    <UserIcon/>
                                                    <span
                                                        className={"text-xs text-[var(--color-secondary)]"}>{formatNumber(data.channel.subscribers_count)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <Table
                                            className="">
                                            <TableBody>
                                                {placementStats.map((item) => (
                                                    <TableRow key={item.id}
                                                              className={"last:[&>td]:after:content-none"}>
                                                        <TableCell
                                                            className={"!text-sm !px-0 !pt-4.5 !pb-2.5 text-[var(--color-secondary)] mr-2 relative after:absolute after:left-0 after:bottom-0 after:h-[1px] after:w-[90%] after:bg-[var(--border-color-block)]"}>
                                                            {item.title1}
                                                            <div
                                                                className={"!text-sm text-[var(--text-color-dark)] mt-1"}>
                                                                {item.desc1}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell
                                                            className={"!text-sm !px-0 !pt-4.5 !pb-2.5 text-[var(--color-secondary)] !pl-0 relative after:absolute after:left-0 after:bottom-0 after:h-[1px] after:w-[100%] after:bg-[var(--border-color-block)]"}>
                                                            {item.title2}
                                                            <div
                                                                className={"!text-sm text-[var(--text-color-dark)] mt-1"}>
                                                                {item.desc2}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                    <div className={"flex gap-4 items-center mb-[32px] px-4 cursor-pointer"}
                                         onClick={blackListHandler}>
                                        {!data.channel.blacklisted ? <BanIcon/> : <TrashIcon/>}
                                        <Text className={"!text-sm text-[var(--color-listItem-profile)]"}>
                                            {!data.channel.blacklisted ? t('modals.actions.addToBlacklist') :  t('modals.actions.removeFromBlacklist')}
                                        </Text>
                                    </div>
                                    <div className={"flex gap-4 items-center mb-[32px] px-4 cursor-pointer"}>
                                        <CopyIcon/>
                                        <Text className={"!text-sm text-[var(--color-listItem-profile)]"}
                                              onClick={copyChannel}>
                                            {t('modals.actions.copyChannelLink')}
                                        </Text>
                                    </div>
                                    <LightButton title={t('common.buttons.cancel')} onClick={onClose}/>
                                </div>
                            </div>
                            : ''
                    }
                </IsLoadingContainer>
            }
        </BottomSheet>
    )
}